import { render, staticRenderFns } from "./ExpenseAndPayrollRelated.vue?vue&type=template&id=2f1ced72"
import script from "./ExpenseAndPayrollRelated.vue?vue&type=script&lang=js"
export * from "./ExpenseAndPayrollRelated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports